import { render, staticRenderFns } from "./PartOtherListHandler.vue?vue&type=template&id=6fe22956"
import script from "./PartOtherListHandler.vue?vue&type=script&lang=ts"
export * from "./PartOtherListHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports